/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppMessagesRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {GetAppMessagesResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const getAppMessages = (request: GetAppMessagesRequest, options?: CashRequestOptions) => post<GetAppMessagesRequest, GetAppMessagesResponse>("/2.0/cash/get-app-messages", request, {...options, rejectOnError: true })